import { convertColours } from "$lib/db/shop";
import { writable } from "svelte/store";

export const shopColours = writable<Colours>(convertColours({}));